module.exports = __webpack_public_path__ + "img/ImmerDieseFotos.95e57186.jpg";